// Modules
import React from 'react';
import { useSelector } from 'react-redux';

// Styles
import { NoResultView } from './no-resut.styles';
import { BodyBold } from '../../styles/common/typo.styles';

// Constant
import { constant } from '../../constants/contant';

// Selector
import { capitalizedLang } from '../../selectors/common.selector';

const NoResults = () => {
	const lang = useSelector((state: any) => capitalizedLang()(state));

	return (
		<NoResultView>
			<BodyBold>{constant[lang].VARIABLES.NO_RESULT}</BodyBold>
		</NoResultView>
	);
};

export default NoResults;
